"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

import { useFeatureFlagContext } from "../components/FeatureFlagProvider/context";
import type { FeatureFlagEnum } from "../core";

export function useActiveFeatureFlags(): FeatureFlagEnum[] | undefined {
  const client = usePostHog();
  const { bootstrap } = useFeatureFlagContext();

  const [featureFlags, setFeatureFlags] = useState<FeatureFlagEnum[] | undefined>(
    bootstrap &&
      (Object.keys(bootstrap.featureFlags ?? {}).filter(key => bootstrap.featureFlags[key]) as FeatureFlagEnum[])
  );

  useEffect(() => {
    client.onFeatureFlags(flags => {
      setFeatureFlags(flags as FeatureFlagEnum[]);
    });
  }, [client]);

  return featureFlags;
}
